export enum MemberJourneyStepStatus {
    Committed = 'Committed',
    CompletedSuccess = 'CompletedSuccess',
    CompletedReject = 'CompletedReject',
    Skipped = 'Skipped'
}
